import { render } from "./LoyerItem.vue?vue&type=template&id=139dbce5"
import script from "./LoyerItem.vue?vue&type=script&lang=js"
export * from "./LoyerItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__